import React from 'react'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
import { isAuthenticated } from './auth'

const AuthRoute = ({ component: Component, redirectTo, ...rest}) => {
    const authenticated = isAuthenticated();
    return (
        <Route
            {...rest}
            render={(props) => (
                authenticated ? (
                    <Component type={rest.type} key={rest.key} {...props} />
                ) : (
                    <Redirect to={{
                        pathname: redirectTo,
                        state: { from: props.location }
                    }}
                    />
                )
            )}
        />
    )
}

AuthRoute.propTypes = {
    authenticated: PropTypes.bool,
    component: PropTypes.func.isRequired,
}

AuthRoute.defaultProps = {
    authenticated: false,
    redirectTo: "/login"
}

export default AuthRoute